import { Element } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Context } from "../../../context.js";
import { PseudoClassSelector } from "./pseudo-class.js";
const { hasName } = Element;
const { and, not, test } = Predicate;
/**
 * {@link https://drafts.csswg.org/selectors/#enableddisabled}
 * {@link https://html.spec.whatwg.org/multipage#selector-enabled}
 */
export class Enabled extends PseudoClassSelector {
    static of() {
        return new Enabled();
    }
    constructor() {
        super("enabled");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return test(and(hasName("button", "input", "select", "textarea", "optgroup", "option", "fieldset"), not(Element.isActuallyDisabled)), element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Enabled) {
    Enabled.parse = PseudoClassSelector.parseNonFunctional("enabled", Enabled.of);
})(Enabled || (Enabled = {}));
//# sourceMappingURL=enabled.js.map